export const colors = {
  infoBorder: '#CCCCCC',
  invalidBorder: '#CB0B2F',
  primary: '#2495D4',
  unselected: '#28292A',
  disabled: '#A29992',
  warningRed: '#E95344',
};
